import {
  Directive,
  ElementRef,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges
} from '@angular/core';
import { CoreImageViewService } from '../services/core-image-view.service';
import { attachImageHoverPreview } from '../utils/image-hover-preview.util';

/**
 * Shows the entity's first image as a small floating thumbnail when
 * hovering the host element (typically an eye icon). Usage:
 * `<i appImageHoverPreview [entityType]="'asset'" [entityId]="assetId"></i>`
 */
@Directive({
  selector: '[appImageHoverPreview]'
})
export class ImageHoverPreviewDirective
  implements OnInit, OnChanges, OnDestroy
{
  @Input() entityType!: string;
  @Input() entityId!: number;

  private detach?: () => void;

  constructor(
    private el: ElementRef<HTMLElement>,
    private coreImageView: CoreImageViewService
  ) {}

  ngOnInit(): void {
    this.attach();
  }

  ngOnChanges(changes: SimpleChanges): void {
    const entityTypeChanged = changes['entityType'] && !changes['entityType'].firstChange;
    const entityIdChanged = changes['entityId'] && !changes['entityId'].firstChange;
    if (entityTypeChanged || entityIdChanged) {
      this.detach?.();
      this.attach();
    }
  }

  ngOnDestroy(): void {
    this.detach?.();
  }

  private attach(): void {
    this.detach = attachImageHoverPreview(this.el.nativeElement, () =>
      this.coreImageView.getFirstImageUrl(this.entityType, this.entityId)
    );
  }
}
